module.exports = __webpack_public_path__ + "static/media/phone.171f2b32.svg";